import { memo } from 'react';
import { Product } from '../../../../models';
import CategoryLabel from '../../../../../../shared/components/CategoryLabel';
import { ProductTypes } from '../../../../../../shared/constants';
import RenderHtml from '../../../../../../shared/components/RenderHtml';

interface ProductHeaderSectionProps {
  product: Product;
}

function ProductHeaderSection({ product }: ProductHeaderSectionProps) {
  const showBundleLabel =
    !product?.bundleOptions.some((bundleOption) =>
      bundleOption.title
        ?.toLowerCase()
        .includes(ProductTypes.membership.toLowerCase()),
    ) && product?.bundleProduct;

  return (
    <>
      <div>
        {showBundleLabel && (
          <CategoryLabel type="Bundle" className="mb-3 me-2 float-start" />
        )}
        <CategoryLabel type={product.type} className="mb-3 d-inline-flex" />
      </div>
      <RenderHtml html={product.name} tag="h3" className="fs-4" />
    </>
  );
}

export default memo(ProductHeaderSection);
